import { Button, Input, Space } from 'antd';
import { getStoredValue, setStoredValue } from '../hooks/GeneralStoreHooks';
import { useEffect, useState } from 'react';
import { refreshAllDatasets } from '../hooks/DatasetHooks';
import { RefContextLanguage } from '../providers/LanguageProvider';

export function FilterComponent({ filterId }) {
  const i18n = RefContextLanguage();

  useEffect(() => {
    setStoredValue(filterId, null);
  }, [filterId]);

  const [inputValue, setInputValue] = useState(() => getStoredValue(filterId));

  const cleanAndSaveEnteredValue = (value) => {
    const cleanedValue = value.trim();
    setInputValue(cleanedValue);
    setStoredValue(filterId, cleanedValue);
  };

  return (
    <Space direction="horizontal">
      <Button type="primary" onClick={() => refreshAllDatasets()}>
        {i18n.t('refreshAll')}
      </Button>
      <Input placeholder={i18n.t('filter')} value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
      <Button type="primary" onClick={() => cleanAndSaveEnteredValue(inputValue)}>
        {i18n.t('filter')}
      </Button>
      <Button
        type="primary"
        onClick={() => {
          setInputValue(null);
          setStoredValue(filterId, null);
        }}
        danger
      >
        {i18n.t('clear')}
      </Button>
    </Space>
  );
}
